import { getStatusColor } from '@/utils/statusColor';
import { useTheme } from '@mui/material/styles';
import {
  CircleCheck,
  CircleX,
  Percent,
  TrendingDown,
  TrendingUp,
} from 'lucide-react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useStatsChartInfo = (stats) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        id: 0,
        name: TrendingUp,
        color: theme.palette.status.stats.min,
        title: t('tools.traceroute.minimum'),
        value: stats.min,
      },
      {
        id: 1,
        name: TrendingDown,
        color: theme.palette.status.stats.max,
        title: t('tools.traceroute.maximum'),
        value: stats.max,
      },
      {
        id: 2,
        name: CircleCheck,
        color: theme.palette.status.stats.max,
        title: t('tools.traceroute.average'),
        value: stats.avg,
      },
      {
        id: 3,
        name: CircleCheck,
        color: theme.palette.status.online,
        title: t('tools.traceroute.successes'),
        value: stats.successes,
      },
      {
        id: 4,
        name: CircleX,
        color: theme.palette.status.offline,
        title: t('tools.traceroute.failures'),
        value: stats.failures,
      },
      {
        id: 5,
        name: Percent,
        color: getStatusColor(stats.percent, theme),
        title: t('tools.traceroute.successRate'),
        value: stats.percent,
      },
    ],
    [stats, theme, t]
  );
};
